import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  makeSyncReduxWithLocalStorageObserver,
  restoreFromLocalStorage,
} from 'app/dataManagement/syncReduxStateWithLocalStorage';
import observeStore from 'app/utils/redux/observeStore';

export const STORAGE_LOCAL_STORAGE_KEY = 'redux.storage';

export type AutomaticCleanupMode = 'all' | 'pacs' | 'none';

interface StorageState {
  automaticCleanupMode: AutomaticCleanupMode;
  lastWarningThreshold: number;
}

const initialState: () => StorageState = () => ({
  automaticCleanupMode: 'none',
  lastWarningThreshold: null, // 30GB in bytes
  ...restoreFromLocalStorage(STORAGE_LOCAL_STORAGE_KEY),
});

const storageSlice = createSlice({
  name: 'storage',
  initialState,
  reducers: {
    setAutomaticCleanupMode(state: StorageState, action: PayloadAction<AutomaticCleanupMode>) {
      state.automaticCleanupMode = action.payload;
      state.lastWarningThreshold = null;
    },
    setLastWarningThreshold(state: StorageState, action: PayloadAction<number>) {
      state.lastWarningThreshold = action.payload;
    },
  },
});

export const { setAutomaticCleanupMode, setLastWarningThreshold } = storageSlice.actions;

export type StoreWithStorage = {
  storage: StorageState;
};

export const selectStorage = (state: StoreWithStorage) => state.storage;

export const attachStorageWithLocalStorageSynchronizationObserver = (store: StoreWithStorage) => {
  observeStore(
    store,
    selectStorage,
    makeSyncReduxWithLocalStorageObserver(STORAGE_LOCAL_STORAGE_KEY)
  );
};

const storageReducer = storageSlice.reducer;

export default storageReducer;
